// CSS for animated work indicator
export const workIndicatorStyle = `
  .work-indicator-bar {
    width: 12px;
    height: 22px;
    background:rgb(255, 187, 0);
    position: absolute;
    overflow: hidden;
    z-index: 0;
  }
  .work-indicator-bar::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 300%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0,0 L4,4 L0,8' stroke='white' stroke-width='2.5' fill='none'/%3E%3C/svg%3E");
    background-size: 20px 14px;
    background-repeat: repeat-x;
    background-position: 0 5px;
    animation: workChevronMove 2s linear infinite;
  }
  @keyframes workChevronMove {
    0% {
      transform: translateX(-30px);
    }
    100% {
      transform: translateX(30px);
    }
  }
  .story-field input {
    background: transparent !important;
    border: none !important;
    color: gray !important;
    border-radius: 4px !important;
    font-size: 10px !important;
    padding: 1px 3px !important;
    min-width: 50px !important;
    box-shadow: none !important;
    height: auto !important;
  }
  .story-field input:focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }
`;

